import { render, staticRenderFns } from "./verbaleDismissioneGVR.vue?vue&type=template&id=cdbe1198"
import script from "./verbaleDismissioneGVR.vue?vue&type=script&lang=js"
export * from "./verbaleDismissioneGVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports